import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'callbackFilter',
  pure: false,
  standalone: false,
})
export class CallbackFilterPipe implements PipeTransform {
  transform(items: any[], callback: (item: any) => boolean, skipFiltering = false): any {
    if (!items || !callback) {
      return items;
    }
    return items.filter((item) => skipFiltering || callback(item));
  }
}
